import React, { useEffect, useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import "react-confirm-alert/src/react-confirm-alert.css";
import moment from "moment";
import { HiOutlineCash, HiOutlineCalendar, HiOutlineCreditCard, HiUser } from 'react-icons/hi';

import { useAtom } from "jotai";
import { gbState } from "../../../components/shared/GlobalState";

const MemberOutstandingPaymentChild = () => {
  let navigate = useNavigate();
  const [data, setData] = useState([]);
  const [outstandingMonth, setOutstandingMonth] = useState(0);
  const [outstandingAmt, setOutstandingAmt] = useState(0);
  const [receipt, setReceipt] = useState([]);
  const [doj, setDoj] = useState(true);

  //Error Logging Service
  const [{ errorLogApi, user }] = useAtom(gbState);

  useEffect(() => {
    const getDataFromServer = () => {
      let userToken = localStorage.getItem("token");

      let urlLink = `${process.env.REACT_APP_API_URL}/subscriber/id/${user?._id}`;

      console.log(urlLink);

      const config = {
        method: "GET",
        url: urlLink,
        headers: {
          Authorization: `Bearer ${userToken}`,
        },
      };

      axios(config)
        .then(function (response) {
          console.log(response.data.subscriber);
          const subscriber = response.data.subscriber;

          const updatedData = {
            ...subscriber,
            id: subscriber?._id,
            date: subscriber?.date_of_joining,
            name:
              subscriber?.subscriber_id?.first_name +
              " " +
              subscriber?.subscriber_id?.last_name,
            role: subscriber?.subscriber_id?.user_type,
            monthly_subscription: subscriber?.monthly_subscription,
          };

          setData(updatedData);
        })
        .catch(function (err) {
          console.log("error api call ", err);
        });
    };

    getDataFromServer();
  }, []);

  useEffect(() => {
    const fetchLastPayment = (user_id) => {
      let userToken = localStorage.getItem("token");
      let urlLink = `${process.env.REACT_APP_API_URL}/receipt/last_payment/${user_id}`;
      const config = {
        method: "GET",
        url: urlLink,
        headers: {
          Authorization: `Bearer ${userToken}`,
        },
      };

      axios(config)
        .then(function (response) {
          const last_payment = response.data.receipts;
          const newDate = new Date(moment(last_payment.payment_date));
          setReceipt({ ...last_payment, paid_upto: newDate });
        })
        .catch(function (err) {
          console.log("error occurred.");
        });
    };
    fetchLastPayment(user?._id);
  }, []);

  function calculateSubscriptionCost(subscriptionObj, memberObj) {
    const currentDate = new Date();
    let startDate;
    let monthlyAmount;

    if (
      (Array.isArray(subscriptionObj) && subscriptionObj?.length === 0) ||
      subscriptionObj === null
    ) {
      // Use date_of_joining from member object
      startDate = new Date(memberObj?.date_of_joining);
      monthlyAmount = parseInt(memberObj?.monthly_subscription, 10);
    } else {
      // Use paid_upto from subscription object
      const paidUpToDate = new Date(subscriptionObj?.paid_upto);
      startDate = new Date(
        paidUpToDate.getFullYear(),
        paidUpToDate.getMonth() + 1,
        1
      );
      monthlyAmount = parseInt(subscriptionObj?.amount, 10);
    }

    const monthsDiff = monthDifference(startDate, currentDate);
    setOutstandingMonth(monthsDiff);
    return monthsDiff * monthlyAmount;
  }

  function monthDifference(dateFrom, dateTo) {
    let months = (dateTo.getFullYear() - dateFrom.getFullYear()) * 12;
    months -= dateFrom.getMonth();
    months += dateTo.getMonth();
    return months <= 0 ? 0 : months;
  }

  useEffect(() => {
    if (data && receipt) {
      const cost = calculateSubscriptionCost(receipt, data);
      setOutstandingAmt(cost);
    }
  }, [data, receipt]);

  useEffect(() => {
    if (outstandingMonth) {
      setDoj(false);
    } else {
      setDoj(true);
    }
  }, [outstandingMonth]);

  return (
    <div className="w-full bg-white rounded-lg border border-gray-200 shadow-sm">
      <div className="p-6">
        {/* Header */}
        <div className="flex justify-between items-center mb-6">
          <div className="flex items-center space-x-3">
            <div className="p-2 bg-blue-50 rounded-lg">
              <HiUser className="w-6 h-6 text-blue-600" />
            </div>
            <div>
              <h2 className="text-xl font-semibold text-gray-900">{user?.name}</h2>
              <p className="text-sm text-gray-500">Payment Summary</p>
            </div>
          </div>
          <button
            onClick={() => navigate("/member/memberpayments")}
            disabled={doj}
            className="inline-flex items-center px-4 py-2 text-sm font-medium text-white bg-blue-600 rounded-lg transition-colors duration-200 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 disabled:opacity-50 disabled:cursor-not-allowed"
          >
            <HiOutlineCreditCard className="mr-2 w-5 h-5" />
            Pay Now
          </button>
        </div>

        {/* Payment Details */}
        <div className="space-y-4">
          {/* Outstanding Amount */}
          <div className="flex justify-between items-center p-4 bg-gray-50 rounded-lg">
            <div className="flex items-center space-x-3">
              <div className="p-2 bg-red-50 rounded-lg">
                <HiOutlineCash className="w-5 h-5 text-red-600" />
              </div>
              <div>
                <p className="text-sm font-medium text-gray-500">Outstanding Amount</p>
                <p className="text-lg font-semibold text-gray-900">$ {outstandingAmt || 0}</p>
              </div>
            </div>
          </div>

          {/* Outstanding Month */}
          <div className="flex justify-between items-center p-4 bg-gray-50 rounded-lg">
            <div className="flex items-center space-x-3">
              <div className="p-2 bg-yellow-50 rounded-lg">
                <HiOutlineCalendar className="w-5 h-5 text-yellow-600" />
              </div>
              <div>
                <p className="text-sm font-medium text-gray-500">Outstanding Month</p>
                <p className="text-lg font-semibold text-gray-900">{outstandingMonth || 0} months</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MemberOutstandingPaymentChild;
